<template>
  <section class="app-community">
    <CommonAnchorSlider :catalog="catalog" />
    <section class="app-community-content">
      <template v-for="(item, index) in ModuleMenuList" :key="index">
        <component
          :is="item.type"
          :id="`community-${index + 1}`"
          class-name="mt-6 first:mt-0"
          :title="item.title"
          :list="item.list"
          :ratio="16.5 / 9"
        />
      </template>
    </section>
  </section>
</template>

<script setup lang="ts">
import { ModuleCLCommunityEvents, ModuleCLCommunityVideos, ModuleCLCommunityMaps } from '#components'
const pageStore = usePageStore()
const { fetchPageData, filterModule } = pageStore
const { modules } = storeToRefs(pageStore)
await fetchPageData('/cl-community/') // path与后台定义的path一致

const ModuleMenuList = computed(() => {
  const data: any[] = []
  modules.value.forEach((module) => {
    const list = module.detail.events || module.detail.videos || module.detail.maps || []
    const component = resolveComponentName(module.component_name)
    data.push({
      type: component,
      ...module.detail,
      list
    })
  })
  return data
})
const catalog = computed(() => {
  return ModuleMenuList.value.map((item, index) => {
    return {
      title: item.title,
      link: `community-${index + 1}`
    }
  })
})
function resolveComponentName(name: string) {
  if (name.includes('Events')) return resolveComponent('ModuleCLCommunityEvents')
  if (name.includes('Videos')) return resolveComponent('ModuleCLCommunityVideos')
  if (name.includes('Maps')) return resolveComponent('ModuleCLCommunityMaps')
  return ''
}
</script>

<style lang="scss" scoped>
.app-community {
  @apply relative flex pt-5 ltr:pl-9 ltr:pr-17 rtl:pl-17 rtl:pr-9;
}

.app-community-content {
  @apply flex-1 pb-16 ltr:pl-8 rtl:pr-8;
}
</style>
